export default __webpack_public_path__ + "img/reward_1-2-b8387c8c.png";